const root = document.documentElement;

const themes = {
    SubTheme1: { // Yellow
        backGroundColor: '#FFFFFF',
        primaryUnderlineColor: '#5CB279',
        secondaryUnderlineColor: '#8F80AC',
        mobilMenuColor: '#5CB279',
        primaryColor: '#FEF096',
        secondaryColor: '#FFF5B9',
        tertiaryColor: '#F2F2F2',
        calendarColor: '#F2F2F2',
        footerColor: '#F2F2F2',
        primaryFont: "TT Norms Pro"
    },
    SubTheme2: { // Blue
        backGroundColor: '#FFFFFF',
        primaryUnderlineColor: '#6991BB',
        secondaryUnderlineColor: '#8F80AC',
        mobilMenuColor: '#6991BB',
        primaryColor: '#B3C8DD',
        secondaryColor: '#D5EDF7',
        tertiaryColor: '#F2F2F2',
        calendarColor: '#F2F2F2',
        footerColor: '#F2F2F2',
        primaryFont: "TT Norms Pro"
    },
    SubTheme3: { // Green
        backGroundColor: '#FFFFFF',
        primaryUnderlineColor: '#00872E',
        secondaryUnderlineColor: '#8F80AC',
        mobilMenuColor: '#00872E',
        primaryColor: '#c1f2b5',
        tertiaryColor: '#F2F2F2',
        calendarColor: '#F2F2F2',
        footerColor: '#F2F2F2',
        primaryFont: "TT Norms Pro"
    },
    BusinessTheme: {
        backGroundColor: '#FFFFFF',
        primaryUnderlineColor: '#000',
        secondaryUnderlineColor: '#000',
        mobilMenuColor: '#000',
        primaryColor: '#000',
        secondaryColor: '#FFF',
        tertiaryColor: '#F2F2F2',
        calendarColor: '#F2F2F2',
        footerColor: '#F2F2F2',
        primaryFont: "TT Norms Pro"
    },
    Stavanger2025: {
        backGroundColor: '#E8E3DE',
        primaryUnderlineColor: '#87A1DE',
        secondaryUnderlineColor: '#8F80AC',
        mobilMenuColor: '#406640',
        primaryColor: '#97B878',
        secondaryColor: '#FFBE3D',
        tertiaryColor: '#FFBE3E',
        calendarColor: '#F2F2F2',
        footerColor: '#FFEBCA',
        primaryFont: "Lydian"
    },
    SubTheme4: { // New subtheme, orange
        backGroundColor: '#FFFFFF',
        primaryUnderlineColor: '#FF95FD',
        secondaryUnderlineColor: '#8F80AC',
        mobilMenuColor: '#452C75',
        primaryColor: '#D6ECDD',
        secondaryColor: '#ADD8BB',
        tertiaryColor: '#D6ECDD',
        calendarColor: '#E2F8DA',
        footerColor: '#F2F2F2',
        primaryFont: "TT Norms Pro"
    },
    SubTheme5: { // New subtheme,  color dark yellow
        backGroundColor: '#FFFFFF',
        primaryUnderlineColor: '#713B38',
        secondaryUnderlineColor: '#8F80AC',
        mobilMenuColor: '#713B38',
        primaryColor: '#FFC6A4',
        secondaryColor: '#DBCDCD',
        tertiaryColor: '#FFC6A4',
        calendarColor: '#F2F2F2',
        footerColor: '#F2F2F2',
        primaryFont: "TT Norms Pro"
    },
    KlimaStavanger: { // New subtheme,  color dark yellow
        backGroundColor: '#F2F2F2',
        primaryUnderlineColor: '#88E468',
        secondaryUnderlineColor: '#8F80AC',
        mobilMenuColor: '#88E468',
        primaryColor: '#CFF4C3',
        secondaryColor: '#FFFFFF',
        tertiaryColor: '#FFFFFF',
        calendarColor: '#F2F2F2',
        footerColor: '#FFFFFF',
        primaryFont: "TT Norms Pro"
    },
}

let selectedTheme;

if ($("body").hasClass("SubTheme2")) {
    selectedTheme = themes['SubTheme2'];
}
else if ($("body").hasClass("SubTheme3")) {
    selectedTheme = themes["SubTheme3"];
}
else if ($("body").hasClass("BusinessTheme")) {
    selectedTheme = themes["BusinessTheme"];
}
else if ($("body").hasClass("Stavanger2025")) {
    selectedTheme = themes["Stavanger2025"];
}
else if ($("body").hasClass("SubTheme4")) {
    selectedTheme = themes["SubTheme4"];
}
else if ($("body").hasClass("SubTheme5")) {
    selectedTheme = themes["SubTheme5"];
}
else if ($("body").hasClass("KlimaStavanger")) {
    selectedTheme = themes["KlimaStavanger"];
}
else {
    selectedTheme = themes["SubTheme1"];
}


root.style.setProperty('--sub-primary-underline-color', selectedTheme.primaryUnderlineColor);
root.style.setProperty('--sub-secondary-underline-color', selectedTheme.secondaryUnderlineColor);
root.style.setProperty('--sub-mobil-menu-color', selectedTheme.mobilMenuColor);
root.style.setProperty('--sub-primary-color', selectedTheme.primaryColor);
root.style.setProperty('--sub-secondary-color', selectedTheme.secondaryColor);
root.style.setProperty('--sub-tertiary-color', selectedTheme.tertiaryColor);
root.style.setProperty('--sub-calender-color', selectedTheme.calendarColor);
root.style.setProperty('--sub-footer-color', selectedTheme.footerColor);
root.style.setProperty('--sub-background-color', selectedTheme.backGroundColor);
root.style.setProperty('--sub-primary-font', selectedTheme.primaryFont);


// Add css-variables if IE browser
if (window.document.documentMode) {
    cssVars({
        onlyLegacy: true,
        variables: {
            '--sub-primary-underline-color': selectedTheme.primaryUnderlineColor,
            '--sub-secondary-underline-color': selectedTheme.secondaryUnderlineColor,
            '--sub-mobil-menu-color': selectedTheme.mobilMenuColor,
            '--sub-primary-color': selectedTheme.primaryColor,
            '--sub-secondary-color': selectedTheme.secondaryColor,
            '--sub-tertiary-color': selectedTheme.tertiaryColor,
            '--sub-calender-color': selectedTheme.calendarColor,
            '--sub-footer-color': selectedTheme.footerColor,
            '--sub-background-color': selectedTheme.backGroundColor,
            '--sub-primary-font': selectedTheme.primaryFont
        }
    });
}
